import EmberObject from "@ember/object";
import discourseComputed from "discourse-common/utils/decorators";
export default EmberObject.extend(dt7948.p({
  isLastVisited() {
    return this.lastVisitedTopic === this.topic;
  }
}, [["method", "isLastVisited", [discourseComputed]]]));